import socket from "socket.io-client";
import store from "@/store";

let io = null,
  url = process.env.VUE_APP_API_URL;

// const options = {
// 	"force new connection" : true,
// 	"reconnection": true,
// 	"reconnectionDelay": 2000,                  //starts with 2 secs delay, then 4, 6, 8, until 60 where it stays forever until it reconnects
// 	"reconnectionDelayMax" : 60000,             //1 minute maximum delay between connections
// 	"reconnectionAttempts": "Infinity",         //to prevent dead clients, having the user to having to manually reconnect after a server restart.
// 	"timeout" : 2000,                           //before connect_error and connect_timeout are emitted.
// 	"transports" : ["websocket"]
// }
const token = window.getCookie("x-pulse-token");
if (token) io = socket(url, { query: "token=" + token });
else io = socket(url);

io.on("FINANCE_UPDATE_DAY", data => {
  store.commit("finance/updateDate", data);
  store.dispatch("finance/getPayoutByDay", data);
  window.$notify({ type: "success", message: "finance_dayadd_success" });
});
io.on("FINANCE_PAYOUT_UPDATE", data =>
  store.commit("finance/updatePayout", data)
);
io.on("FINANCE_PAYOUT_REMOVE_DAY", data =>
  store.commit("finance/removePayoutDate", data)
);
io.on("FINANCE_PAYOUT_ADDUSERS", data =>
  store.commit("finance/addUserToPayout", data)
);
io.on("FINANCE_PAYOUT_REMOVE_USER", data =>
  store.commit("finance/removeUserFromPayout", data)
);

io.on("FINANCE_PAYROLL_ADDMONTH", data =>
  store.commit("finance/updateMonth", data)
);
io.on("FINANCE_PAYROLL_UPDATE", data =>
  store.commit("finance/updatePayroll", data)
);
io.on("FINANCE_PAYROLL_REMOVE_MONTH", data =>
  store.commit("finance/removePayrollMonth", data)
);
io.on("FINANCE_PAYROLL_ADDUSERS", data =>
  store.commit("finance/addUserToPayroll", data)
);
io.on("FINANCE_PAYROLL_REMOVE_USER", data =>
  store.commit("finance/removeUserFromPayroll", data)
);

export const recreateIo = () => {
  const token = window.getCookie("x-pulse-token");
  if (token) io = socket(url, { query: "token=" + token });
};

export default io;
